module.exports = __webpack_public_path__ + "img/p1-info@2x.b74a4661.jpg";